const FBIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_459)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9489 0.484863C18.8335 0.51778 21.4394 1.22672 23.7667 2.61169C26.0662 3.96902 27.9791 5.89358 29.3224 8.20136C30.6989 10.5427 31.4036 13.1644 31.4364 16.0665C31.3547 20.0374 30.1022 23.4288 27.6791 26.241C25.256 29.0531 22.1526 30.7928 18.9399 31.4598V20.3268H21.9772L22.6641 15.9518H18.0649V13.0863C18.0394 12.4923 18.2272 11.9087 18.5945 11.4411C18.9623 10.9722 19.61 10.7258 20.5376 10.7018H23.3149V6.86941C23.2751 6.85659 22.8969 6.80589 22.1805 6.71731C21.3681 6.62224 20.551 6.57147 19.733 6.56521C17.8817 6.57375 16.4175 7.09598 15.3405 8.13192C14.2634 9.16756 13.7133 10.6659 13.6899 12.627V15.9518H10.1899V20.3268H13.6899V31.4598C9.74525 30.7928 6.64181 29.0531 4.21869 26.241C1.79556 23.4288 0.543188 20.0374 0.461426 16.0665C0.494138 13.1643 1.1988 10.5425 2.5754 8.20136C3.9187 5.89359 5.83158 3.96902 8.13113 2.61169C10.4584 1.22699 13.0643 0.518047 15.9489 0.484863Z"
          fill="#1F2937"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_459">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default FBIcon;
